// TODO - Type 'any' needs to be fixed.
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type JobFiltersProps = {
	roles: any[];
};

const JobFilters = ({ roles }: JobFiltersProps) => {
	const { t } = useTranslation();
	const [jobExpand, setJobExpand] = React.useState<boolean>(false);

	if (roles.length === 0) return null;

	return (
		<Box display='flex' flexWrap='wrap' alignItems='center' mt={1} mb={1}>
			<Typography
				sx={{
					fontWeight: 400,
					fontSize: 14,
					fontFamily: "Roboto",
					color: "#000000",
					flexWrap: "wrap",
					marginRight: 1,
				}}
			>
				{t("scheduler_job-roles")} -
			</Typography>
			{roles.length > 0 ? (
				roles
					.slice(0, jobExpand ? undefined : 5)
					.map((role: any, index: number) => (
						<Box key={`role-${role}-${index}`} mr={0.8}>
							<Typography
								sx={{
									fontWeight: 400,
									fontSize: 14,
									fontFamily: "Roboto",
									color: "#000000",
								}}
							>
								{`${role.name}${index === roles.length - 1 ? "" : ","}`}
							</Typography>
						</Box>
					))
			) : (
				<></>
			)}
			{roles.length >= 5 ? (
				<Button onClick={(e) => setJobExpand(!jobExpand)} size='small'>
					{jobExpand ? t("scheduler_show-less") : t("scheduler_show-more")}
				</Button>
			) : null}
		</Box>
	);
};

export default JobFilters;
